import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskFactorsPanel = ({ riskFactors }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Critical':
        return 'text-error bg-red-50 border-red-200';
      case 'High':
        return 'text-warning bg-amber-50 border-amber-200';
      case 'Medium':
        return 'text-accent bg-yellow-50 border-yellow-200';
      case 'Low':
        return 'text-success bg-green-50 border-green-200';
      default:
        return 'text-text-secondary bg-muted border-border';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'Critical':
        return 'AlertTriangle';
      case 'High':
        return 'AlertCircle';
      case 'Medium':
        return 'Info';
      case 'Low':
        return 'CheckCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-forensic-card">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="Shield" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-text-primary">Risk Factors</h3>
      </div>
      <div className="space-y-4">
        {riskFactors?.map((factor, index) => (
          <div key={index} className={`p-4 rounded-lg border ${getSeverityColor(factor?.severity)}`}>
            <div className="flex items-start space-x-3">
              <Icon 
                name={getSeverityIcon(factor?.severity)} 
                size={18} 
                color="currentColor" 
                className="mt-0.5 flex-shrink-0"
              />
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-sm">{factor?.title}</h4>
                  <span className="text-xs font-medium px-2 py-1 rounded-full bg-white bg-opacity-50">
                    {factor?.severity}
                  </span>
                </div>
                <p className="text-sm opacity-90 mb-2">{factor?.description}</p>
                <div className="flex items-center justify-between text-xs">
                  <span>Impact Score: {factor?.impactScore}/100</span>
                  <span>Confidence: {factor?.confidence}%</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-center justify-between text-sm">
          <span className="font-medium text-text-primary">Overall Risk Assessment</span>
          <div className="flex items-center space-x-4">
            <span className="text-text-secondary">
              {riskFactors?.filter(f => f?.severity === 'Critical')?.length} Critical
            </span>
            <span className="text-text-secondary">
              {riskFactors?.filter(f => f?.severity === 'High')?.length} High
            </span>
            <span className="text-text-secondary">
              {riskFactors?.filter(f => f?.severity === 'Medium')?.length} Medium
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskFactorsPanel;